export const governmentHeroContent = {
  title: 'Job-ready talent: Economic growth',
  description: 'Udacity creates job opportunities with GDP impact for nations embracing the global digital era.',
  cta: {
    label: 'Learn More',
    href: '/get-started/government',
  },
  backgroundImages: {
    desktop: '/images/government/hero/hero-bg-desktop.jpg',
    mobile: '/images/government/hero/hero-bg-mobile.jpg',
  },
};
